import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { usePageContent } from "@/i18n/pageContent";

const PARTNERS = [
  { name: "AEREC Osaka", img: "/partner-aerec-osaka.png", url: "" },
  { name: "Meta Communications", img: "/partner-meta-communications.png", url: "https://www.metacommunications.it/" },
  { name: "Addictive Ideas", img: "/partner-addictive-ideas.png", url: "https://addictiveideas.com/", dark: true },
  { name: "Enosis", img: "/partner-enosis.webp", url: "https://www.enosissrl.it/" },
  { name: "ICS", img: "/partner-ics.svg", url: "" },
  { name: "Spicy", img: "/partner-spicy.png", url: "" },
  { name: "Greenhill", img: "/partner-greenhill.png", url: "" },
];

const SPONSORS = [
  { name: "WJ Network", img: "/sponsor-wj-network.png", url: "https://www.wjnetwork.it/" },
  { name: "Tesori d'Italia Network", img: "/sponsor-tesori-italia.png", url: "https://www.tesoriditalianetwork.it/" },
  { name: "Caffè Cola", img: "/sponsor-caffe-cola.png", url: "https://www.caffecola.it/" },
  { name: "WJapan", img: "/sponsor-wjapan.jpg", url: "" },
];

const PATRONAGE = [
  { name: "Romania", img: "/patrocinio-romania.png", url: "https://roma.mae.ro/it" },
  { name: "Poland", img: "/patrocinio-poland.png", url: "https://www.gov.pl/web/italia/ambasciata-a-roma" },
  { name: "Latvia", img: "/patrocinio-latvia.png", url: "https://www2.mfa.gov.lv/it/" },
  { name: "Greece", img: "/patrocinio-greece.png", url: "https://www.mfa.gr/italy/it/the-embassy/" },
  { name: "Belgium", img: "/patrocinio-belgium.png", url: "https://italy.diplomatie.belgium.be/it" },
  { name: "Czech Republic", img: "/patrocinio-czech.jpg", url: "https://mzv.gov.cz/rome/it/index.html" },
  { name: "Bulgarian Institute of Culture", img: "/patrocinio-bulgaria.jpg", url: "https://www.ibcroma.it/" },
  { name: "Cyprus", img: "/patrocinio-cyprus.jpg", url: "" },
  { name: "Slovak Institute Rome", img: "/patrocinio-slovak.jpg", url: "https://www.mzv.sk/sirim" },
  { name: "AEREC Osaka 2025", img: "/patrocinio-aerec-osaka-2025.png", url: "https://www.aerec.org/" },
];

function LogoCell({ item }) {
  const dark = !!item.dark;
  const inner = (
    <div
      className={`h-32 md:h-36 flex items-center justify-center border transition-colors p-6 ${
        dark
          ? "bg-[#0f2340] border-[#0f2340] hover:border-[#d4af37]"
          : "bg-white border-[#e2e8f0] hover:border-[#d4af37]"
      }`}
    >
      {item.img ? (
        <img
          src={item.img}
          alt={item.name}
          loading="lazy"
          className="max-h-full max-w-full object-contain"
        />
      ) : (
        <span
          className={`font-display text-base md:text-lg text-center leading-tight tracking-wide ${
            dark ? "text-white" : "text-[#1a365d]"
          }`}
        >
          {item.name}
        </span>
      )}
    </div>
  );
  return item.url ? (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      title={item.name}
      className="block reveal"
    >
      {inner}
      <div className="mt-2.5 text-[11px] tracking-[0.16em] uppercase text-[#475569] font-body text-center">
        {item.name}
      </div>
    </a>
  ) : (
    <div title={item.name} className="reveal">
      {inner}
      <div className="mt-2.5 text-[11px] tracking-[0.16em] uppercase text-[#475569] font-body text-center">
        {item.name}
      </div>
    </div>
  );
}

function Section({ eyebrow, title, items, bg }) {
  return (
    <section className={`${bg} py-20 md:py-24`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="mb-12 reveal">
          <span className="eyebrow">{eyebrow}</span>
          <h2 className="font-display text-3xl md:text-5xl text-[#1a365d] mt-4 leading-tight">
            {title}
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-6">
          {items.map((it) => (
            <LogoCell key={it.name} item={it} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Partners() {
  const c = usePageContent("partners");
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
      />

      <Section
        eyebrow={c.s1Eyebrow}
        title={c.s1Title}
        items={PARTNERS}
        bg="bg-white"
      />
      <Section
        eyebrow={c.s2Eyebrow}
        title={c.s2Title}
        items={SPONSORS}
        bg="bg-[#fafaf7]"
      />
      <Section
        eyebrow={c.s3Eyebrow}
        title={
          <>
            {c.s3TitleA} <span className="italic">{c.s3TitleB}</span>.
          </>
        }
        items={PATRONAGE}
        bg="bg-white"
      />
    </PageShell>
  );
}
